export const GATEWAY_PATH = "/gateway";
